<template>
  <div class="subject">
    <div class="form">
      <el-form ref="formCustom" :model="formCustom" :rules="addRules" class="formCustom" label-width="150px"
               status-icon>
        <el-form-item label="行业类型：" prop="industryType">
          <el-select v-model="formCustom.industryType" placeholder="请选择" style="width: 400px;">
            <el-option v-for="(item, index) in industryTypeList" :key="index + 'type'" :label="item.itemText"
                       :value="item.itemValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业名称：" prop="companyName">
          <el-input v-model="formCustom.companyName" autocomplete="off" class="input"
                    placeholder="请输入企业名称"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码：" prop="organizationCode">
          <el-input v-model="formCustom.organizationCode" autocomplete="off" class="input"
                    placeholder="请输入统一社会信用代码"></el-input>
        </el-form-item>
        <el-form-item label="法人姓名：" prop="owner">
          <el-input v-model="formCustom.owner" autocomplete="off" class="input" placeholder="请输入法人姓名"></el-input>
        </el-form-item>
        <el-form-item label="企业注册地：" prop="countyCode">
          <el-cascader v-model="formCustom.countyCode" :options="areaData" :props="props" filterable
                       placeholder="请选择企业注册地" style="width: 400px;"></el-cascader>
        </el-form-item>
        <el-form-item label="企业规模：" prop="companyScale">
          <el-select v-model="formCustom.companyScale" placeholder="请选择" style="width: 400px;">
            <el-option v-for="(item, index) in companyScaleList" :key="index + 'type'" :label="item.itemText"
                       :value="item.itemValue"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="营业执照：" prop="businesslicenseCodeUrl">
          <el-upload :action="upAction" :file-list="fileList" :headers="getToken" :limit="1"
                     :on-error="error" :on-exceed="handleExceed" :on-success="success"
                     accept=" .jpg, .jpeg, .png, .bmp, .pdf"
                     class="upload-demo" multiple>
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">上传营业执照照片或者扫描件 信息需清晰可见，内容真实有效，不可做任何修改
              只支持.jpg .jpeg .png .bmp .pdf格式
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button :loading="submitLoading" class="next" type="primary" @click="submitForm('formCustom')">提交
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {allDivisionTree} from '@/api/public'
import {companyScaleList, industryTypeList} from '@/api/authority'
import {companyAdd} from '@/api/organization'

export default {
  name: "companyApplyAdd",
  props: {
    row: {
      // 定义接收的类型 还可以定义多种类型 [String, Undefined, Number]
      // 如果required为true,尽量type允许undefined类型，因为传递过来的参数是异步的。或者设置默认值。
      type: Object,
      // 定义是否必须传
      required: true,
      // 定义默认值
      default: {}
    }
  },
  data() {
    const industryProp = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择行业类型"))
      } else {
        callback()
      }
    };
    const companyNameProp = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入企业名称"));
      } else {
        callback();
      }
    };
    const organizationCodeProp = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入统一社会信用代码"));
      } else {
        callback();
      }
    };
    const ownerProp = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入法人姓名"));
      } else {
        callback();
      }
    };
    const addressProp = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择企业注册地"));
      } else {
        callback();
      }
    };
    const scaleProp = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择企业规模"));
      } else {
        callback();
      }
    };
    const fileProp = (rule, value, callback) => {
      if (this.fileList.length == 0) {
        callback(new Error("请上传营业执照"));
      } else {
        callback();
      }
    };

    return {
      formCustom: {
        industryType: "",
        companyName: "",
        organizationCode: "",
        owner: "",
        countyCode: "",
        companyScale: ""
      },
      areaData: [],
      companyScaleList: [],
      industryTypeList: [],
      fileList: [],
      getToken: {Authorization: 'Bearer ' + localStorage.getToken},
      upAction: this.$getImg + 'api/auth/img',
      props: {value: 'id'},
      submitLoading: false,
      addRules: {
        industryType: [{validator: industryProp, trigger: "blur"}],
        companyName: [{validator: companyNameProp, trigger: "blur"}],
        organizationCode: [{validator: organizationCodeProp, trigger: "blur"}],
        owner: [{validator: ownerProp, trigger: "blur"}],
        countyCode: [{validator: addressProp, trigger: "blur"}],
        companyScale: [{validator: scaleProp, trigger: "blur"}],
        file: [{validator: fileProp, trigger: "blur"}]
      }
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      allDivisionTree().then((response) => {
        this.areaData = response.data.data
        this.forAreaData(this.areaData)
      })
      industryTypeList().then((response) => {
        this.industryTypeList = response.data.data
      })
      companyScaleList().then((response) => {
        this.companyScaleList = response.data.data
      })
    },
    forAreaData(v) {
      v.forEach((s) => {
        if (s.children.length == 0) {
          Reflect.deleteProperty(s, 'children')

        } else {
          this.forAreaData(s.children)
        }
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    success(response, file, fileList) {
      this.fileList = fileList
    },
    error(err) {
      console.log(err)
    },
    submitForm(formName) {
      this.submitLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          companyAdd({
            industryType: this.formCustom.industryType,
            companyName: this.formCustom.companyName,
            organizationCode: this.formCustom.organizationCode,
            owner: this.formCustom.owner,
            countyCode: this.formCustom.countyCode.slice(-1)[0],
            companyScale: this.formCustom.companyScale,
            businesslicenseCodeUrl: this.fileList[0].response ? this.fileList[0].response.data : this.fileList[0].data,
            isCreateAdmin: 1
          }).then((response) => {
            this.submitLoading = false
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
            } else {
              this.$alert('企业创建已提交审核，1-3工作日系统管理员会审核完成。', '提交成功', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$emit('addSuccess')
                }
              })
            }
          })
        } else {
          this.submitLoading = false
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.subject {
  .select {
    display: flex;
    flex-direction: column;
    align-items: center;

    .box-card {
      margin-top: 80px;
      text-align: left;
      width: 700px;

      .h {
        font-size: 24px;
        margin-bottom: 10px;
      }

      .item {
        font-size: 16px;
      }
    }
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .next {
      border-radius: 4px;
      background-color: rgba(0, 123, 211, 1);
      color: rgba(255, 255, 255, 1);
      font-size: 18px;
      height: 50px;
      border-color: #3a62d7;
      width: 300px;
    }

    .formCustom {
      margin-left: 30px;

      .input {
        width: 400px;
      }
    }

    .back {
      cursor: pointer;
      width: 376px;
      color: rgba(16, 16, 16, 1);
      font-size: 16px;
      text-align: left;

      i {
        border: 3px solid black;
        border-width: 0px 1px 1px 0px;
        display: inline-block;
        padding: 5px;
      }

      .left {
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
      }
    }
  }
}
</style>
